import React, { useState, useEffect } from 'react';

const IframeProtections = ({ children }) => {
  const [isInIframe, setIsInIframe] = useState(false);

  useEffect(() => {
    if (window.self !== window.top) {
      setIsInIframe(true);
    }
  }, []);

  if (isInIframe) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f0f0f0',
        fontFamily: 'Arial, sans-serif'
      }}>
        <div style={{
          textAlign: 'center',
          padding: '20px',
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        }}>
          <svg viewBox="0 0 24 24" width="48" height="48" style={{ margin: '0 auto 20px' }}>
            <circle cx="12" cy="12" r="10" fill="#ff6b6b" />
            <line x1="4" y1="20" x2="20" y2="4" stroke="white" strokeWidth="2" />
          </svg>
          <h2 style={{ color: '#333', marginBottom: '10px' }}>Content Blocked</h2>
          <p style={{ color: '#666' }}>This content cannot be displayed in a frame.</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default IframeProtections;